import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as agendaActions from '../actions/Agenda';
import * as agendaApi from '../api/Agenda';
import { showErrorNotification } from '../actions/App';
import { GET_AGENDA_LIST, GET_AGENDA_DETAILS } from '../constants/ActionTypes';

function* getAgendaList({ payload }) {
  yield put(agendaActions.setAgendaListLoading(true));

  try {
    const { data } = yield call(agendaApi.getAgendaList, payload.studentId, payload.date);

    yield put(agendaActions.getAgendaListSuccess({ items: data.items, date: payload.date }));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }

  yield put(agendaActions.setAgendaListLoading(false));
}

function* getAgendaDetails({ payload }) {
  yield put(agendaActions.setAgendaDetailsLoading(true));

  try {
    const { data } = yield call(
      agendaApi.getAgendaDetails,
      payload.studentId,
      payload.date,
      payload.routeId,
    );

    yield put(
      agendaActions.getAgendaDetailsSuccess({ routeId: payload.routeId, ...data }, payload.date),
    );
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }

  yield put(agendaActions.setAgendaDetailsLoading(false));
}

export default function* rootSaga() {
  yield all([
    takeLatest(GET_AGENDA_LIST, getAgendaList),
    takeLatest(GET_AGENDA_DETAILS, getAgendaDetails),
  ]);
}
